// src/components/premium/GatePremium.jsx
//
// Wrapper ÚNICO de bloqueio visual tier-aware. NÃO cria blur novo: REUTILIZA o
// BlurPlan.jsx existente como camada visual (fonte visual única).
//
// - feature: chave de FEATURES (ex.: 'mapaMuscularInteligente', 'graficosEvolucao')
// - contexto: payload p/ o paywall contextual do Prompt 4 (ex.: { origem, detalhe })
//
// Comportamento:
//   LIBERADO  (PREMIUM/VINCULADO) → renderiza children SEM nenhuma alteração.
//   BLOQUEADO (GRATUITO)          → children dentro do BlurPlan (blur + cadeado +
//                                   área clicável) → abrirPaywall({ feature, ...contexto }).
//
// Guardrail: durante o carregamento dos entitlements, renderiza SEM overlay
// (otimista) — assim PREMIUM/VINCULADO nunca "piscam" borrados.

import React from "react";
import BlurPlan from "../layout/BlurPlan.jsx";
import { useEntitlements } from "../../hooks/useEntitlements";
import { usePaywall } from "../../contexts/PaywallContext.jsx";

export default function GatePremium({
  redesign = false,
  feature,
  contexto,
  message = "Recurso Turbo",
  blur,
  children,
}) {
  const { can, loading } = useEntitlements();
  const { abrirPaywall } = usePaywall();

  // Liberado (ou ainda resolvendo o tier) → sem overlay.
  if (loading || can(feature)) return <>{children}</>;

  return (
    <BlurPlan
      locked
      redesign={redesign}
      message={message}
      blur={blur}
      onUnlock={() => abrirPaywall({ feature, ...(contexto || {}) })}
    >
      {children}
    </BlurPlan>
  );
}
